import Vue from 'vue';
import App from './App.vue';
import router from './router';
import i18n from './locales';
import VueCookies from 'vue-cookies';
import VueScreen from 'vue-screen'; // https://github.com/reegodev/vue-screen
import './stylesheets/tailwind.css';
import './stylesheets/app.scss';
import '../src/directives/click-outside';

Vue.use(VueCookies);
Vue.use(VueScreen);
Vue.config.productionTip = false;

Vue.component('ProfilingBoolean', () => import('./components/ui-elements/ProfilingBoolean'));
Vue.component('ProfilingCheckbox', () => import('./components/ui-elements/ProfilingCheckbox'));
Vue.component('ProfilingInput', () => import('./components/ui-elements/ProfilingInput'));
Vue.component('ProfilingGuide', () => import('./components/ui-elements/ProfilingGuide'));
Vue.component('ProfilingRadio', () => import('./components/ui-elements/ProfilingRadio'));
Vue.component('ProfilingQuestion', () => import('./components/ui-elements/ProfilingQuestion'));
Vue.component('ProfilingSelect', () => import('./components/ui-elements/ProfilingSelect'));
Vue.component('ProfilingTallyCounter', () => import('./components/ui-elements/ProfilingTallyCounter'));
Vue.component('SwButton', () => import('./components/generic/SwButton'));
Vue.component('SwCheckbox', () => import('./components/generic/SwCheckbox'));
Vue.component('SwCheckboxGroup', () => import('./components/generic/SwCheckboxGroup'));
Vue.component('SwCollapse', () => import('./components/generic/SwCollapse'));
Vue.component('SwDate', () => import('./components/ui-elements/SwDate'));
Vue.component('GenericDate', () => import('./components/generic/GenericDate'));
Vue.component('SwDrawer', () => import('./components/generic/SwDrawer'));
Vue.component('SwDropdown', () => import('./components/generic/SwDropdown'));
Vue.component('SwFlash', () => import('./components/generic/SwFlash'));
Vue.component('SwIcon', () => import('./components/generic/SwIcon'));
Vue.component('SwInput', () => import('./components/generic/SwInput'));
Vue.component('SwMarkdownTextarea', () => import('./components/ui-elements/SwMarkdownTextarea'));
Vue.component('SwModal', () => import('./components/generic/SwModal'));
Vue.component('SwModal', () => import('./components/generic/SwModal'));
Vue.component('SwPanel', () => import('./components/generic/SwPanel'));
Vue.component('SwProgressTracker', () => import('./components/generic/SwProgressTracker'));
Vue.component('SwPopover', () => import('./components/generic/SwPopover'));
Vue.component('SwRadio', () => import('./components/generic/SwRadio'));
Vue.component('SwSelect', () => import('./components/generic/SwSelect'));
Vue.component('SwSpeechBalloon', () => import('./components/ui-elements/SwSpeechBalloon'));
Vue.component('SwStep', () => import('./components/generic/SwStep'));
Vue.component('SwSubNav', () => import('./components/generic/SwSubNav'));
Vue.component('SwTab', () => import('./components/generic/SwTab'));
Vue.component('SwTableOfContents', () => import('./components/generic/SwTableOfContents'));
Vue.component('SwTabs', () => import('./components/generic/SwTabs'));
Vue.component('SwTooltip', () => import('./components/generic/SwTooltip'));
Vue.component('TheCivilLiabilityForm', () => import('./components/ui-elements/TheCivilLiabilityForm'));
Vue.component('TheFlashMessages', () => import('./components/ui-elements/TheFlashMessages'));
Vue.component('TheObfuscatedLinksHandler', () => import('./components/generic/TheObfuscatedLinksHandler'));
Vue.component('TheHeader', () => import('./components/ui-elements/TheHeader'));
Vue.component('TheNavigation', () => import('./components/ui-elements/TheNavigation'));
Vue.component('TheOperatorDrawer', () => import('./components/ui-elements/TheOperatorDrawer'));

Vue.component('DocMarkdown', () => import('./views/shared/markdown'));
Vue.component('DocPreview', () => import('./views/shared/preview'));

Vue.directive('click-outside', {

});

new Vue({
  router,
  i18n,
  render: (h) => h(App),
}).$mount('#app');
